import KeyMirror from 'keymirror';

export default KeyMirror({
    UPDATE_RESULTS: true,
    RESET_RESULTS: true,
    INCREMENT_VISITS: true,
});
